<template>
  <div id="now_v2">
    <v-container fluid>
      <v-row>
        <v-col
          cols="6"
          md="6"
          sm="6"
        >
          <v-select
            v-model="fieldListValue"
            :items="fieldList"
            label="選擇場域"
            solo
            @input="fieldChange"
          />
        </v-col>
        <v-col
          cols="6"
          md="6"
          sm="6"
        >
          <v-select
            v-model="didListValue"
            :items="didList"
            label="設備編號"
            solo
            @input="didChange"
          />
        </v-col>
      </v-row>

      <v-alert
        v-show="kpidataarray.length > 0"
        color="#C51162"
        dark
        style="font-size: 18px"
        border="right"
      >
        <div
          v-for="(item, index) in kpidataarray"
          :key="index"
        >
          <v-avatar class="">       
            <v-img :src="item.val_icon" />
          </v-avatar>
          {{ item.c_val_name }} {{ item.value }}{{ item.val_unit }}
        </div>
      </v-alert>
      <v-row>
        <v-col
          v-for="item in sensorData"
          :key="item.text"
          cols="12"
          md="3"
          sm="12"
        >
          <v-card
            style="min-height: 310px"
            color="#E8F5E9"
          >
            <v-card-text>             
              <div v-if="item.SWITCH">
                <span style="font-size:30px;font-weight:bold ;color:#008000">{{ item.did }} {{ '             ' }}</span>
                <span style="font-size:12px; color:#000000;text-align:right">　{{ item.text }} </span>
                <br>
                <br>
                <font-awesome-icon
                  v-if="item.value == 0"
                  style="font-size: 8em"
                  :icon="['fas', 'toggle-off']"
                />
                <font-awesome-icon
                  v-else
                  style="font-size: 8em;color:#008000"
                  :icon="['fas', 'toggle-on']"
                />
                <br>
                <br>
                <v-row>
                  <v-col cols="12">
                    <br><br> <br><br> <br><br> <br><br> 
                    更新時間<br>
                    {{ item.date }}
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row>
                  <v-col cols="4">
                    <span style="font-size:30px;font-weight:bold ;color:#008000">{{ item.did }}</span>
                    <v-avatar
                      class="ma-3"
                      tile
                    >
                      <v-img :src="item.icon" />
                    </v-avatar>
                  </v-col>
                  <v-col cols="8">
                    <div
                      class="inner-text"
                      style="
                      width: 144px !important;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: normal;
                    "
                    >
                      <span style="max-width:100px ; font-size:18px;font-weight:bold">{{ item.text }}</span>
                      <br>
                      <br>
                      <span style="font-size:24px; color:#000000">{{ item.valuestr }}</span>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <line-example
                      v-show="item.chartshow"
                      class="chart"
                      :display="false"
                      :chart="item.chart"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    更新時間<br>
                    {{ item.date }}
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <v-card-actions />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import LineExample from "./LineChart.js";
import { VueSvgGauge } from "vue-svg-gauge";
import moment from "moment";
import Cookies from "js-cookie";

export default {
  components: {
    LineExample,
  },
  
  data: () => ({
    time: null,
    kpidataarray: [],
    fieldStatus: "",
    sensorData: [
      { value: 40, text: "a", chart: false },
      { value: 90, text: "b", chart: false },
    ],
    drawer: null,
    chart: {
      labels: ["11:00", "11:05", "11:10"],
      datasets: [
        {
          label: "Data One",
          borderColor: "#FC2525",
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "white",
          data: [40, 39, 70],
        },
      ],
    },
    updatetime: "",
    fieldList: ["", "測試用"],
    fieldListValue: "",
    deviceList: ["01"],
    pages: [1, 2, 3, 4],
    startAngle: -110,
    endAngle: 110,
    value: 75,
    separatorStep: 0,
    min: 0,
    max: 100,
    scale: 0,
    innerRadius: 60,
    separatorThickness: 4,
    baseColor: "#d0cdcd",
    easingFct: "Circular",
    easingType: "Out",
    didListValue: "ALL",
    didList: [],
    filterDevice: {},
  }),
  computed: {
    easing() {
      const { easingFct, easingType } = this;
      return [easingFct, easingType].join(".");
    },
    host() {
      return this.$store.state.host;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    loginUID() {
      return this.$store.state.loginUID;
    },
    exec_cust_gateway_000() {
      return this.$store.state.exec_cust_gateway_000;
    },
  },
  created: function () {
    Cookies.set("url", "/Home");
    this.updatetime = moment().format("YYYY-MM-DD HH:mm:ss");
    this.init();

    this.time = setInterval(() => {
      this.fieldChange(this.fieldListValue);
    }, 120 * 1000);
  },
  unmounted() {
    if (this.time) {
      clearInterval(this.time);
    }
  },
  methods: {
    init() {
      let that = this;
      let nform = {
        cust_id: this.loginInfo.cust_id,
      };

      this.fieldList = [];
      this.$store
        .dispatch("exec_cust_gateway_000", nform)
        .then((res) => {
          if (this.loginUID.superuser == "0") {
            nform = {
              cust_id: this.loginInfo.cust_id,
              uid: this.loginInfo.uid,
            };

            this.$store
              .dispatch("exec_uid_gateway_000", nform)
              .then((res) => {
                if (res != null && res.length > 0) {
                  for (var i = 0; i < res.length; i++) {
                    let gw_no = res[i].gw_no;

                    for (
                      var j = 0;
                      j < this.exec_cust_gateway_000.length;
                      j++
                    ) {
                      let item = this.exec_cust_gateway_000[j];

                      if (gw_no == item.ip_adrs) {
                        this.fieldList.push(item.gw_desc);
                      }
                    }
                  }
                  if (this.fieldList != null && this.fieldList.length > 0) {
                    if (
                      this.fieldListValue == null ||
                      this.fieldListValue == ""
                    ) {
                      this.fieldListValue = this.fieldList[0];
                    } else {
                    }
                  }
                  this.fieldChange(this.fieldListValue);
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.fieldList = this.exec_cust_gateway_000.map(function (item) {
              return item.gw_desc;
            });

            if (this.fieldList != null && this.fieldList.length > 0) {
              if (this.fieldListValue == null || this.fieldListValue == "") {
                this.fieldListValue = this.fieldList[0];
              } else {
              }

              //  console.log(this.fieldListValue);
            }

            this.fieldChange(this.fieldListValue);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    fieldChange(val) {
      this.fieldListValue = val;
      this.kpidataarray = [];
      this.filterDevice = this.exec_cust_gateway_000.filter(function (
        item,
        index,
        array
      ) {
        return item.gw_desc == val;
      });

      if (this.filterDevice != null && this.filterDevice.length > 0) {
        let nform = {
          cond: this.filterDevice[0].ip_adrs,
          did: this.didListValue,
        };

        let that = this;
        this.sensorData = [];
        this.$store
          .dispatch("exec_device_now_v2_000", nform)
          .then((res) => {
            if (res != null && res.length > 0) {
              for (var i = 0; i < res.length; i++) {
                let item = res[i];
                let SWITCH = false;
                if (item.val_type == "3") {
                  SWITCH = true;
                }
                let e_dat = this.todatetime;
                e_dat = moment().format("YYYY-MM-DD HH:mm:ss");
                this.chartAjax(item, e_dat, SWITCH);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });

        nform = {
          cond: this.filterDevice[0].ip_adrs,
        };

        this.$store
          .dispatch("exec_equip_valname_000", nform)
          .then((res) => {
            if (res != null && res.length > 0) {
              this.didList = res.map(function (item) {
                return item.did;
              });
              this.didList = this.didList.filter(this.onlyUnique);
              this.didList.unshift("ALL");
            }
          })
          .catch((err) => {
            console.log(err);
          });

        nform = {
          cond: this.filterDevice[0].ip_adrs,
        };

        this.$store
          .dispatch("exec_kpi_data_000", nform)
          .then((res) => {
            if (res != null && res.length > 0) {
              this.kpidataarray = res.map(function (item) {
                if (item.val_icon != null)
                  item.val_icon = that.host + "/php/" + item.val_icon;
                return item;
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    didChange(val) {
      let vall = val + " ";
      if (val == "ALL") {
        vall = "ALL";
      }

      this.didListValue = val;
      let nform = {
        cond: this.filterDevice[0].ip_adrs,
        did: vall,
      };
      this.sensorData = [];
      this.$store
        .dispatch("exec_device_now_v2_000", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            for (var i = 0; i < res.length; i++) {
              let item = res[i];
              let SWITCH = false;
              if (item.val_name == "SWITCH") {
                SWITCH = true;
              }
              let e_dat = this.todatetime;
              e_dat = moment().format("YYYY-MM-DD HH:mm:ss");
              this.chartAjax(item, e_dat, SWITCH);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    chartAjax(item, e_dat, SWITCH) {
      let nform = {
        ip_adrs: this.filterDevice[0].ip_adrs,
        did: item.did,
        e_dat: e_dat,
        c_val_name: item.c_val_name,
      };

      this.$store
        .dispatch("exec_history_003", nform)
        .then((res1) => {
          let chart = {
            labels: [],
            datasets: [],
          };
          let chartshow = false;

          if (res1 != null && res1 != "not found" && res1.length >= 10) {
            let lastthree = res1.length - 10;
            let label = [];
            let value = [];
            for (var j = lastthree; j < res1.length; j++) {
              let datearr = res1[j].mdat.split(" ");
              label.push(datearr[1]);
              value.push(res1[j].value);
            }

            chartshow = true;
            chart = {
              labels: label,
              datasets: [
                {
                  label: "Data One",
                  borderColor: "#FC2525",
                  pointBackgroundColor: "white",
                  borderWidth: 1,
                  pointBorderColor: "white",
                  data: value,
                },
              ],
            };
          } else if (res1 != null && res1 != "not found" && res1.length >= 3) {
            let lastthree = res1.length - 3;
            let label = [];
            let value = [];
            for (var j = lastthree; j < res1.length; j++) {
              let datearr = res1[j].mdat.split(" ");
              label.push(datearr[1]);
              value.push(res1[j].value);
            }

            chartshow = true;
            chart = {
              labels: label,
              datasets: [
                {
                  label: "",
                  borderColor: "#FC2525",
                  pointBackgroundColor: "white",
                  borderWidth: 1,
                  pointBorderColor: "white",
                  data: value,
                },
              ],
            };
          }

          let icon = item.val_icon;
          if (icon != "") {
            icon = this.host + "/php/" + icon;
          }

          let obj = {
            did: item.did+" ",
            idx_id: item.did+" "+item.c_val_name,
            text:   item.c_val_name + " ",
            value: item.value,
            valuestr: item.value + "  " + item.val_unit,
            val_unit: item.val_unit,
            SWITCH: SWITCH,
            key: item.val_unit + item.value,
            GW_sts: item.GW_sts,
            chart: chart,
            chartshow: chartshow,
            icon: icon,
            date: item.dat,
            
          };

          this.sensorData.push(obj);
          this.sensorData.sort(this.compare);
         
        })
        .catch((err) => {
          console.log(err);
        });
    },
    compare(a, b) {
      if (a.idx_id < b.idx_id) {
        return -1;
      }
      if (a.idx_id > b.idx_id)  {
 
        return 1;
      }
 
      return 0;
    },
  },
};
</script>

<style>
.chart {
  width: 100% !important;
  margin-right: 10px;
  float: left;
  height: 100% !important;
  max-height: 200px !important;
}

.inner-text {
  width: 100%;
  height: 100%;
}

.inner-text--3 {
  display: flex;
  justify-content: center;
  margin-top: 85px;
  font-size: 20px;
  color: #21a2de;
  font-weight: 700;
}
</style>

<style scoped>
#now_v2{
height: 100%;
background-color: #263238;
}
</style>